import { SalesChannel } from "../../../../lib/shopifyInfo";

/** The synchronizer splits the sales channels on ',' */
export const parsePublicationIds = (csv: string): string[] => {
    const publicationIds = csv.split(",").map((publicationId) => publicationId.trim());

    return publicationIds.filter(Boolean);
};

export const serializePublicationIds = (publicationIds: string[]): string => {
    const uniqueIds = Array.from(new Set(publicationIds));

    return uniqueIds.join(",");
};

/** Returns the updated selection after toggling one channel, ordered by the Shopify list. */
export const toggleChannel = (
    selectedIds: string[],
    channels: SalesChannel[],
    toggledId: string,
): string[] => {
    const isSelectedAfterToggle = (publicationId: string) =>
        publicationId === toggledId
            ? !selectedIds.includes(publicationId)
            : selectedIds.includes(publicationId);

    const knownPublicationIds = channels.map((channel) => channel.publicationId);

    return knownPublicationIds.filter(isSelectedAfterToggle);
};

// Order the groups are rendered in
const CATEGORIES = ["Online Store", "Hydrogen", "Other sales channels"] as const;

type SalesChannelCategory = typeof CATEGORIES[number];

type SalesChannelGroup = {
    title: SalesChannelCategory;
    channels: SalesChannel[];
};

const categorizeSalesChannel = (channel: SalesChannel): SalesChannelCategory => {
    const name = (channel.name ?? "").toLowerCase();

    switch (true) {
        case name.includes("online store"):
            return "Online Store";
        case name.includes("hydrogen"):
            return "Hydrogen";
        default:
            return "Other sales channels";
    }
};

export const groupSalesChannelsByCategory = (channels: SalesChannel[]): SalesChannelGroup[] => {
    const groups = CATEGORIES.map((title) => ({
        title,
        channels: channels.filter((channel) => categorizeSalesChannel(channel) === title),
    }));

    return groups.filter((group) => group.channels.length > 0);
};
